const returnLink: {
  read(storage: Storage, host: string, now: number): string | undefined;
  clear(storage: Storage): void;
} = require('../../public/mobile-payment-return');
const receipt: {
  read(storage: Storage, host: string, now: number): unknown;
  clear(storage: Storage): void;
} = require('../../public/mobile-payment-receipt');

export function hasMobilePaymentReceipt(): boolean {
  try {
    return !!receipt.read(sessionStorage, document.location.hostname, Date.now());
  } catch {
    return false;
  }
}

export function getMobileAppReturn(): string | undefined {
  try {
    return returnLink.read(localStorage, document.location.hostname, Date.now());
  } catch {
    return;
  }
}

export function clearMobileAppReturn(): void {
  try {
    returnLink.clear(localStorage);
  } catch {
    /* Existing legacy checkout also works without browser storage. */
  }
  try {
    receipt.clear(sessionStorage);
  } catch {
    /* Tab storage may also be unavailable. */
  }
}
